import request from '../../../helpers/request';

const editRoomTenant = async (data) => {
  await request.put(
    `/RentPlace/rental_house/office/tenant`,
    data,
    'При изменении данных арендатора произошла ошибка'
  );
};

export default editRoomTenant;
